import { Injectable } from '@angular/core';
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class CppSraCostSheetService {
  costSheetSimulationDataList: any;
  oldFilters: any;
  isSraCostSheetAccess: string;

  constructor(
    private networkService: NetworkService,
    public configService: ConfigService,
  ) {
  }

  getCostSheetSimulationDataList() {
    return this.costSheetSimulationDataList;
  }

  setOldFilters(value: any) {
    this.oldFilters = value;
  }
  getOldFilters() {
    return this.oldFilters;
  }

  // Get filters data for sra cost sheet retail page dropdown
  public getFilterList() {
    return this.networkService.getRequest(this.configService.sraCostSheetFilterDataUrl);
  }

  public getSRAGridData(filters) {
    return this.networkService.postRequest(this.configService.sraCostSheetLandigGridDataUrl, filters);
  }
  // To get Since Date data
  public getSinceDateData() {
    return this.networkService.getRequest(this.configService.getSinceDateDataUrl);
  }

  public getSRAGridTabDataExport(filters) {
    return this.networkService.postRequest(this.configService.sraCostSheetLandigGridDataExportCostSheetTabExportUrl, filters);
  }

  public getSRAExcelTemplate(filter) {
    return this.networkService.getRequest(this.configService.sraCostSheetDownloadExcelTemplateUrl + '/' + filter);
  }

  // Simulation Grid
  public getSRAGridSimulationData(filters) {
    return this.networkService.postRequest(this.configService.sraCostSheetSimulationGridDataUrl, filters);
  }

  // To get Toggle Settings
  public getToggleSettings(tabName: string) {
    return this.networkService.getRequest(
      this.configService.getAPIPath(this.configService.getToggleSettingsDataUrl, { tabName: tabName })
    );
  }

  // To save Toggle Settings
  public saveToggleSettings(filters) {
    return this.networkService.postRequest(this.configService.saveToggleSettingsDataUrl, filters);
  }

  public saveTempRates(data) {
    return this.networkService.postRequest(this.configService.saveTempRatesDataUrl, data);
  }

  // Decode base64 to file
  public base64toFile(base64String, contentType, fileName) {
    const blob = this.b64toBlob(base64String, contentType, 550);
    saveAs(blob, fileName);
  }

  // Convert b64 to BLOB
  public b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    b64Data = b64Data.replace(/\s/g, ''); // IE compatibility...
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  public getGlossaryData() {
    return this.networkService.getRequest(this.configService.getCppSraCostSheetGlossaryDataUrl);
  }

  public addRemoveItemFavoriteItems(filters) {
    return this.networkService.postRequest(this.configService.setCostFavorite(), filters);
  }
}
